<template>
  <div class="flex flex-col lg:flex-row w-full space-y-0 lg:space-x-6 justify-center lg:py-2">
    <a href="#" @click.prevent="openDonationModal"
      class="bg-pink hover:bg-pink-600 border-2 border-transparent text-white block py-3 lg:py-2 lg:px-12 font-medium uppercase text-center text-base md:rounded-full transform transition-all duration-300 focus:outline-none focus:ring-pink-200">
      Donate
    </a>

    <a  v-if="!this.campaign.pledge_drive" :href="'/create-my-campaign/' + this.campaignId"
        class="bg-blue hover:bg-blue-700 border-2 border-transparent text-white block py-3 lg:py-2 lg:px-12 font-medium uppercase text-center text-base rounded-full transform transition-all duration-300 hidden md:block focus:outline-none focus:ring-blue-200">Fundraise For This Campaign</a>

    <button  v-if="this.campaign.pledge_drive" @click.prevent="openMakePledgeModal"
             class="bg-pink hover:bg-pink-700 border-2 border-transparent text-white block py-3 lg:py-2 lg:px-12 font-medium uppercase text-center text-base rounded-full transform transition-all duration-300 focus:outline-none focus:ring-pink-200">Make a Pledge</button>
    <a  v-if="this.campaign.pledge_drive" :href="'/create-pledge-drive/' + this.campaignId"
        class="bg-blue hover:bg-blue-700 border-2 border-transparent text-white block py-3 lg:py-2 lg:px-12 font-medium uppercase text-center text-base rounded-full transform transition-all duration-300 hidden md:block focus:outline-none focus:ring-blue-200">Support Our Drive</a>

    <make-donation-widget v-if="open_donation" :campaign-id="campaignId" :pledge-id="pledgeId" :campaign="campaign" :key="`sticky_don_`+campaignId"></make-donation-widget>

    <make-pledge-widget v-if="open_pledge" :campaign-id="campaignId"  :campaign="campaign" :key="`sticky_ple_`+campaignId"></make-pledge-widget>
  </div>
</template>

<script>
  import Modal from '../ui/Modal'
  import MakeDonationWidget from '../make-donation/MakeDonationWidget'
  import MakePledgeWidget from '../campaigns/campaign-page/pledge-drives/MakePledgeWidget'


  export default {
    name: 'MyStickyDonateButton',

    components: { MakePledgeWidget, MakeDonationWidget, Modal },

    props: {
      campaignId: {
        required: true,
        type: String,
      },

      campaign: {
        required: false,
      },

      pledgeId: {
        required: false,
        default: '',
      },
    },

    created() {
      this.emitter.on('pledge-modal-close',  () => {
        this.open_pledge = false
      });
      this.emitter.on('donation-modal-close',  () => {
        this.open_donation = false
      });
    },

    data() {
      return {
        isOpen: false,
        donationModalIsOpen: false,
        isSaving: false,
        pledgeForm: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          amount: null,
          amount_limit: null,
          pledge_drive_id: (this.campaign && this.campaign.pledge_drive) ? this.campaign.pledge_drive.id : '',
          campaign_id: this.campaign.id,
        },
        open_pledge: false,
        open_donation: false
      }
    },

    methods: {
      openDonationModal() {
        this.emitter.emit('open-donation-modal');
      },
      openMakePledgeModal() {
        this.emitter.emit('open-pledge-modal');
      },
    },
  }
</script>

<style scoped>

</style>
